// apps/web/src/components/payments/PaymentsManager.tsx
// Payment lifecycle management.

import { ManagerPage } from '../platform/ManagerPage.js';
import type { Payment } from '../../types/payment.js';

export function PaymentsManager() {
  return (
    <ManagerPage
      title="Payments"
      listPath="/api/v1/payments"
      listKey="payments"
      createLabel="New Payment"
      className="payments-manager"
      renderItem={(raw) => {
        const p = raw as Payment;
        return (
          <div className="manager-card" key={p.id}>
            <h3>{p.amount.toLocaleString()} ({p.paymentMethod ?? '—'})</h3>
            <p className="status-badge">{p.status}</p>
            <p>Ref {p.reference ?? '—'}</p>
            <div className="actions">
              <button className="btn btn-secondary">View</button>
              <button className="btn btn-primary">Process</button>
              <button className="btn btn-danger">Refund</button>
            </div>
          </div>
        );
      }}
    />
  );
}